export interface RegisterRequest {
    tenant: string;
    title: string;
    first_name: string;
    last_name: string;
    email: string;
    password: string;
    agent_number: string;
    address_country: string;
    phone_mobile: string;
    legal_accepted: boolean;
    referral_description?: string;
    affiliate_id?: string;
}

export interface RegisterSucceed {
    account_number: string;
    user_id: string;
    contact_number: string;
}

export interface LEADExistsRegisterResult {
    lead_crm_id: string;
}

export interface AccountExistsRegisterResult {
    lead_crm_id: string;
}

export type RegisterResult = RegisterSucceed | LEADExistsRegisterResult | AccountExistsRegisterResult;

export enum ContactMarketingInput {
    EWS_CAMPAIGN_ID = 'EWS-CAMPAIGN-ID',
    EWS_MEDIUM_ID = 'EWS-MEDIUM-ID',
    EWS_SOURCE_ID = 'EWS-SOURCE-ID',
    EWS_CONTENT_ID = 'EWS-CONTENT-ID',
    EWS_TERM_ID = 'EWS-TERM-ID'
}
